import type { Data } from '@/api/api'
import type { RequestProfile } from '@/types/types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}user/`

export const getUserInfo = async (): Promise<Data<RequestProfile>> => axios.get(`${urlPrefix}info/`)
